<template>
  <protected-pages-layout>
  <div>
    <!-- <navbar></navbar> -->
    <div>
      <v-card rounded="0" class="window-wrapper" flat>
        <v-card-actions class="justify-space-between">
          <v-btn icon="mdi-chevron-left" variant="plain" @click="prev" aria-label="Previous step"></v-btn>
          <v-item-group v-model="onboarding" class="text-center" mandatory>
            <v-item
              v-for="n in 3"
              :key="`btn-${n}`"
              v-slot="{ isSelected, toggle }"
              :value="n"
            >
              <v-btn
                :variant="isSelected ? 'outlined' : 'text'"
                icon="mdi-record"
                @click="toggle"
                :aria-label="`Step ${n}${isSelected ? ' (current)' : ''}`"
                :aria-current="isSelected ? 'step' : null"
              ></v-btn>
            </v-item>
          </v-item-group>
          <v-btn icon="mdi-chevron-right" variant="plain" @click="next" aria-label="Next step"></v-btn>
        </v-card-actions>
        <v-window v-model="onboarding">
          <v-window-item key="card-1" :value="1">
              <clientProfitabilityTable />
          </v-window-item>
          <v-window-item key="card-2" :value="2">
            <div>
              <clientEcoOverrunTable/>
            </div>
          </v-window-item>
          <v-window-item key="card-3" :value="3">
            <contractProfitabilityLineChart :lineChartData="lineChartData" />
          </v-window-item>
        </v-window>
      </v-card>
    </div>
  </div>
</protected-pages-layout>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useClientStore } from "../stores/client.js"
const clientStore = useClientStore()

const {
    contractsOverrun
} = storeToRefs(clientStore)

const {
    fetchContractsOverrun
} = clientStore

const isTableReady = ref(false);

let labels = [];
let CSOverrun = [];
let PSOverrun = [];
let MUVResourcesUsageOverrun = [];
let ECOAnnualizedHostingCostOverrun = [];
let ECOTotal = [];
let ECOTotalAnnualised = [];

let lineChartData = ref({
  labels: [],
  datasets: [],
});

onMounted(async () => {
    await fetchContractsOverrun()
    contractsOverrun.value.forEach((item) => {
      labels.push(item.ReportDate);
      CSOverrun.push(item.ECOCSMTime);
      PSOverrun.push(item.ECOPSTime);
      MUVResourcesUsageOverrun.push(item.ECOMUVResourceUsage);
      ECOAnnualizedHostingCostOverrun.push(item.ECOAnnualisedHostingCost);
      ECOTotal.push(item.ECOTotal);
      ECOTotalAnnualised.push(item.TotalAnnualisedCostOverrun);
    })
    isTableReady.value = true
    lineChartData.value = {
    labels: labels,
    datasets: [
      {
        label: "CS Overrun",
        data: CSOverrun,
        borderColor: "#3e95cd",
        fill: false,
        tension: 0.2,
      },
      {
        label: "PS Overrun",
        data: PSOverrun,
        borderColor: "#8e5ea2",
        fill: false,
        tension: 0.2,
      },
      {
        label: "MUV Resources Usage Overrun",
        data: MUVResourcesUsageOverrun,
        borderColor: "#3cba9f",
        fill: false,
        tension: 0.2,
      },
      {
        label: "ECO Total Annualised",
        data: ECOTotalAnnualised,
        borderColor: "#c45850",
        fill: false,
        tension: 0.2,
      },
    ],
  };
})
</script>




<script>
import { defineComponent } from "vue";
import Navbar from "../components/Navbar.vue";
import ClientProfitabilityTable from "../components/clientProfitabilityTable.vue"
import ClientEcoOverrunTable from "../components/clientEcoOverrunTable.vue"
import clientReportContractProfitabilityLineChart from "../components/clientReportContractProfitabilityLineChart.vue"
import { storeToRefs } from "pinia";
import { clientReportTypes, periods, breakdowns } from "../assets/variables.js";
export default {
  components: {
    navbar: Navbar,
    clientProfitabilityTable: ClientProfitabilityTable,
    clientEcoOverrunTable: ClientEcoOverrunTable,
    ContractProfitabilityLineChart: clientReportContractProfitabilityLineChart
  },
  data: () => ({
    length: 3,
    onboarding: 1,
  }),
  methods: {
    next() {
      this.onboarding =
        this.onboarding + 1 > this.length ? 1 : this.onboarding + 1;
    },
    prev() {
      this.onboarding =
        this.onboarding - 1 < 1 ? this.length : this.onboarding - 1;
    },
  },
};
</script>

<style lang="scss">
.window-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: max-content!important;
  width: max-content!important;
}

.button-export-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  gap: 10px;
  margin-top: 1.5%;
  margin-bottom: 20px;
  align-items: start;
  justify-self: start;
}

.chart-wrapper {
  @media (min-width: 50px) {
    width: 95%;
    height: max-content;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    overflow-x: scroll;
    overflow-y: scroll;
  }
  @media (min-width: 768px) {
    width: 95%;
    height: max-content;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    overflow-x: scroll;
    overflow-y: scroll;
  }
  @media (min-width: 1024px) {
    width: 95%;
    height: max-content;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
}

.chart-card-size {
  @media (min-width: 50px) {
    width: max-content;
    height: max-content;
    overflow-x: scroll;
    overflow-y: scroll;
  }
  @media (min-width: 768px) {
    width: 95%;
    height: 75%;
    overflow-x: scroll;
    overflow-y: scroll;
  }
  @media (min-width: 1024px) {
    width: 95%;
    height: 75%;
    overflow: hidden;
  }
}
</style>
